import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { submit } from 'redux-form';

import { POWERSCHOOL_INTEGRATION_FORM_NAME } from 'Common/FormEnum';
import { storeConfiguration } from '../state/powerschool/actions';
import { Main } from 'Containers/';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

import PowerSchoolConfigurationForm from './PowerSchoolConfigurationForm';

class PowerSchoolConfiguration extends Component {
  static propTypes = {
    gradeOptions: PropTypes.array.isRequired,
    siteOptions: PropTypes.array.isRequired,
    languageOptions: PropTypes.array.isRequired,
    configuration: PropTypes.object.isRequired,
    nextStep: PropTypes.func.isRequired,
    stepComplete: PropTypes.func,
    teacherOptions: PropTypes.array.isRequired,
  };

  static defaultProps = {
    stepComplete: () => {},
  };

  state = { onSubmitSuccess: () => {} };

  getMainProps = () => {
    const { loading, submit, nextStep, stepComplete, isDirty } = this.props;

    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Save',
            onClick: () => {
              this.setState(
                {
                  onSubmitSuccess: () => {
                    stepComplete();
                  },
                },
                submit
              );
            },
            loading,
            disabled: !isDirty,
          },
          {
            content: 'Next',
            onClick: () => {
              this.setState(
                {
                  onSubmitSuccess: () => {
                    nextStep();
                  },
                },
                submit
              );
            },
            loading,
          },
        ],
        shown: true,
      },
    };
  };

  handleSubmit = (values, dispatch, props) => {
    if (props.dirty) {
      return this.props.storeConfiguration(values);
    } else {
      this.state.onSubmitSuccess();
    }
  };

  render() {
    const {
      configuration,
      gradeOptions,
      siteOptions,
      languageOptions,
      stepComplete,
      teacherOptions,
    } = this.props;
    return (
      <Main {...this.getMainProps()}>
        <PowerSchoolConfigurationForm
          onSubmit={this.handleSubmit}
          onSubmitSuccess={this.state.onSubmitSuccess}
          stepComplete={stepComplete}
          initialValues={configuration}
          gradeOptions={gradeOptions}
          siteOptions={siteOptions}
          languageOptions={languageOptions}
          teacherOptions={teacherOptions}
        />
      </Main>
    );
  }
}

const mapDispatchToProps = {
  storeConfiguration,
  submit: () => submit(POWERSCHOOL_INTEGRATION_FORM_NAME),
};

const mapStateToProps = state => {
  const { PowerSchoolIntegration } = state.PowerSchoolIntegrationState;
  return {
    loading: PowerSchoolIntegration.loading,
    isDirty: getIsDirty()(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PowerSchoolConfiguration);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/components/PowerSchoolConfiguration.js